<template>
  <div>
    <BaseHeader>
      <template v-slot:title
        >{{
          profileSvc.user.company ? profileSvc.user.company.name : 'Company'
        }}
        Profile</template
      >
    </BaseHeader>

    <b-container class="py-5 my-5 form form-lg">
      <b-row>
        <b-col md="6" offset-md="3">
          <Avatar
            @avatar-uploaded="profileSvc.getInfo"
            @avatar-deleted="profileSvc.getInfo"
            :src="profileSvc.user.company ? profileSvc.user.company.logo : ''"
            :is-company="profileSvc.user.company ? true : false"
            label="Logo"
            class="mb-4"
          />
          <b-form-group
            v-if="profileSvc.user.company"
            label="Company Name"
            label-size="lg"
          >
            <b-form-input
              v-model="profileSvc.user.company.name"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BaseHeader } from '@/components/base'
import Avatar from '@components/Avatar'

export default {
  title() {
    return this.profileSvc.user.company ? this.profileSvc.user.company.name : ''
  },
  components: {
    BaseHeader,

    Avatar
  },
  inject: ['profileSvc']
}
</script>
